import { Component, computed, Input, input, output, signal } from '@angular/core';
import { RadioOption } from '@core/models';
import { AsyncPipe, CurrencyPipe, NgClass, NgIf } from '@angular/common';
import { RadioButtonListComponent } from '../radio-button-list/radio-button-list.component';
import { TranslatePipe } from '@core/pipes';

@Component({
  selector: 'sc-radio-button',
  imports: [NgClass, NgIf, TranslatePipe, AsyncPipe, CurrencyPipe],
  templateUrl: './radio-button.component.html',
})
export class RadioButtonComponent {
  public isChecked = signal(false);

  @Input()
  radioOption: RadioOption;

  public currentIntent = input<number | string | null>(null);
  public requested = input(false);
  public isOutlined = input(true);
  public disabled = input(false);

  public retrieveValue = output<number | string>();

  public intentRequested = computed(() => {
    return this.currentIntent() !== null && this.radioOption?.value === this.currentIntent();
  });

  constructor(private radioButtonListComponent: RadioButtonListComponent) {}

  ngOnInit() {
    this.radioButtonListComponent.addRadioButtonComponent(this);
  }

  check() {
    if (!this.isChecked()) {
      this.isChecked.set(true);
      this.radioButtonListComponent.updateRadioButtonComponent(this);
      this.retrieveValue.emit(this.radioOption.value);
    }
  }
}
